import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';
import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';
import { captureConsoleIntegration, httpClientIntegration, init, replayIntegration } from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

const dsn = atob(environment.sentryDsn);

// ? sentry registeration
init({
  dsn: dsn,
  integrations: [
    replayIntegration(),
    captureConsoleIntegration(),
    httpClientIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));